"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SummaryOfChargesFooter = _interopRequireDefault(require("../SummaryOfChargesFooter"));

var _SummaryOfChargesHotelItem = _interopRequireDefault(require("../SummaryOfChargesHotelItem"));

var _SummaryOfChargesHotelExpenses = _interopRequireDefault(require("../SummaryOfChargesHotelExpenses"));

var _SummaryOfChargesPayNow = _interopRequireDefault(require("../SummaryOfChargesPayNow"));

var _SummaryOfChargesDueAtHotel = _interopRequireDefault(require("../SummaryOfChargesDueAtHotel"));

var _ProperCard = _interopRequireDefault(require("../../../structure/ProperCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SummaryOfChargesHotel(_ref) {
  var className = _ref.className,
      title = _ref.title,
      rooms = _ref.rooms,
      nights = _ref.nights,
      adults = _ref.adults,
      children = _ref.children,
      price = _ref.price,
      subTotal = _ref.subTotal,
      strikethroughPrice = _ref.strikethroughPrice,
      taxes = _ref.taxes,
      resortFees = _ref.resortFees,
      hotelFees = _ref.hotelFees,
      insuranceFees = _ref.insuranceFees,
      grandTotal = _ref.grandTotal,
      displayCurrencySymbol = _ref.displayCurrencySymbol,
      displayCurrencyCode = _ref.displayCurrencyCode,
      sourceCurrencySymbol = _ref.sourceCurrencySymbol,
      sourceCurrencyCode = _ref.sourceCurrencyCode,
      payNowCurrencySymbol = _ref.payNowCurrencySymbol,
      payNowCurrencyCode = _ref.payNowCurrencyCode,
      amenities = _ref.amenities,
      benefits = _ref.benefits,
      rateProviderText = _ref.rateProviderText,
      savedAmount = _ref.savedAmount,
      taxesAndFeesModalContent = _ref.taxesAndFeesModalContent,
      hotelFeesModalContent = _ref.hotelFeesModalContent,
      isEstimated = _ref.isEstimated,
      payNowAmount = _ref.payNowAmount,
      dueAtHotelTax = _ref.dueAtHotelTax,
      dueAtHotelAmount = _ref.dueAtHotelAmount,
      footnoteSymbols = _ref.footnoteSymbols,
      onLookupPage = _ref.onLookupPage,
      cugColor = _ref.cugColor,
      props = _objectWithoutProperties(_ref, ["className", "title", "rooms", "nights", "adults", "children", "price", "subTotal", "strikethroughPrice", "taxes", "resortFees", "hotelFees", "insuranceFees", "grandTotal", "displayCurrencySymbol", "displayCurrencyCode", "sourceCurrencySymbol", "sourceCurrencyCode", "payNowCurrencySymbol", "payNowCurrencyCode", "amenities", "benefits", "rateProviderText", "savedAmount", "taxesAndFeesModalContent", "hotelFeesModalContent", "isEstimated", "payNowAmount", "dueAtHotelTax", "dueAtHotelAmount", "footnoteSymbols", "onLookupPage", "cugColor"]);

  return _react["default"].createElement(_ProperCard["default"], _extends({
    className: className
  }, props), _react["default"].createElement(_SummaryOfChargesHotelItem["default"], {
    title: title,
    price: price,
    strikethroughPrice: strikethroughPrice,
    currencySymbol: displayCurrencySymbol,
    currencyCode: displayCurrencyCode,
    adults: adults,
    children: children,
    amenities: amenities,
    benefits: benefits,
    rateProviderText: rateProviderText,
    savedAmount: savedAmount,
    exclusiveDealFootnote: footnoteSymbols.exclusiveDeal,
    estimatedFootnote: footnoteSymbols.estimatedCurrency,
    cugColor: cugColor
  }), _react["default"].createElement(_SummaryOfChargesHotelExpenses["default"], {
    rooms: rooms,
    nights: nights,
    subTotal: subTotal,
    taxes: taxes,
    hotelFees: hotelFees,
    resortFees: resortFees,
    insuranceFees: insuranceFees,
    taxesAndFeesModalContent: taxesAndFeesModalContent,
    hotelFeesModalContent: hotelFeesModalContent,
    currencySymbol: displayCurrencySymbol,
    currencyCode: displayCurrencyCode
  }), grandTotal && _react["default"].createElement(_SummaryOfChargesFooter["default"], {
    title: isEstimated ? 'Estimated Total Price' : 'Total Trip Price',
    amount: grandTotal,
    prefixText: displayCurrencySymbol,
    suffixText: displayCurrencyCode,
    backgroundColor: "#333",
    textColor: "#FFF",
    footnoteSymbol: footnoteSymbols.estimatedCurrency
  }), !onLookupPage && (payNowAmount || dueAtHotelAmount) && _react["default"].createElement(_SummaryOfChargesPayNow["default"], {
    payNowAmount: payNowAmount,
    dueAtHotelAmount: dueAtHotelAmount,
    currencySymbol: payNowCurrencySymbol,
    currencyCode: payNowCurrencyCode,
    payNowFootNote: footnoteSymbols.payNow
  }), (dueAtHotelAmount > 0 || dueAtHotelTax > 0) && _react["default"].createElement(_SummaryOfChargesDueAtHotel["default"], {
    dueAtHotelAmount: dueAtHotelAmount,
    dueAtHotelTax: dueAtHotelTax,
    currencySymbol: sourceCurrencySymbol,
    currencyCode: sourceCurrencyCode,
    taxFootnote: footnoteSymbols.dueAtHotelTax
  }));
}

SummaryOfChargesHotel.displayName = 'SummaryOfChargesHotel';
SummaryOfChargesHotel.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  rooms: _propTypes["default"].number.isRequired,
  nights: _propTypes["default"].number.isRequired,
  adults: _propTypes["default"].number,
  children: _propTypes["default"].number,
  price: _propTypes["default"].number.isRequired,
  subTotal: _propTypes["default"].number.isRequired,
  strikethroughPrice: _propTypes["default"].number,
  taxes: _propTypes["default"].number,
  resortFees: _propTypes["default"].number,
  hotelFees: _propTypes["default"].number,
  insuranceFees: _propTypes["default"].number,
  grandTotal: _propTypes["default"].number,
  displayCurrencySymbol: _propTypes["default"].string,
  displayCurrencyCode: _propTypes["default"].string,
  sourceCurrencySymbol: _propTypes["default"].string,
  sourceCurrencyCode: _propTypes["default"].string,
  payNowCurrencySymbol: _propTypes["default"].string,
  payNowCurrencyCode: _propTypes["default"].string,
  amenities: _propTypes["default"].arrayOf(_propTypes["default"].string),
  benefits: _propTypes["default"].shape({
    icon: _propTypes["default"].string,
    title: _propTypes["default"].string,
    color: _propTypes["default"].string,
    perks: _propTypes["default"].arrayOf(_propTypes["default"].string)
  }),
  footNote: _propTypes["default"].string,
  savedAmount: _propTypes["default"].number,
  taxesAndFeesModalContent: _propTypes["default"].node,
  isEstimated: _propTypes["default"].bool,
  payNowAmount: _propTypes["default"].number,
  dueAtHotelAmount: _propTypes["default"].number,
  dueAtHotelTax: _propTypes["default"].number,
  footnoteSymbols: _propTypes["default"].shape({
    exclusiveDeal: _propTypes["default"].string,
    estimatedCurrency: _propTypes["default"].string,
    payNow: _propTypes["default"].string,
    dueAtHotelTax: _propTypes["default"].string
  }),
  onLookupPage: _propTypes["default"].bool,
  cugColor: _propTypes["default"].string,
  rateProviderText: _propTypes["default"].string,
  hotelFeesModalContent: _propTypes["default"].node
};
SummaryOfChargesHotel.defaultProps = {
  className: '',
  footnoteSymbols: {}
};

var _default = (0, _react.memo)(SummaryOfChargesHotel);

exports["default"] = _default;